import { useClassName } from '@/styles/Adunit';
import { Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';
import { AdunitPlacementComponent } from './Adunit.Placement';
import { AdunitWrapperComponent } from './Adunit.Wrapper';

export type AdunitProps = ComponentProps<'div'>;

const AdunitComponent: Component<AdunitProps> = ({ children, ...props }) => {
  const className = useClassName('', props);

  return <div {...mergeProps({ className }, props)}>{children}</div>;
};

export const Adunit = Object.assign(AdunitComponent, {
  Wrapper: AdunitWrapperComponent,
  Placement: AdunitPlacementComponent,
});
